import { render } from "./DeviceDataTab.vue?vue&type=template&id=56fb516a&scoped=true"
import script from "./DeviceDataTab.vue?vue&type=script&lang=js"
export * from "./DeviceDataTab.vue?vue&type=script&lang=js"

import "./DeviceDataTab.vue?vue&type=style&index=0&id=56fb516a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56fb516a"]])

export default __exports__